export default "__VITE_ASSET__8e7dcd9b__"